import {createContext} from "react";
import {ErrorContextTypes} from "../types/ErrorContextTypes";

const ErrorContext = createContext<ErrorContextTypes>({
    reportError: () => {
    }
})

export default ErrorContext;